// @ts-strict-ignore
import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { LMModel } from '@form/model/lm-model';

@Component({
  selector:    'lm-form-panel-text',
  templateUrl: './lm-form-panel-text.component.html',
  styleUrls:   [ 'lm-form-panel-text.component.scss' ]
})
export class LMFormPanelTextComponent implements OnInit {

  @Input() model: LMModel;
  @Input() specFields;
  @Input() panelHeader: LMMessageRule;
  @Input() panelText: LMMessageRule;
  @Input() fromDataView: LMDataView;

  public panelHeaderRichTextVars: boolean;
  public panelTextRichTextVars: boolean;
  public panelData: LMModel | LMDataView;
  public panelClass: string;

  constructor() {
  }

  ngOnInit() {
    this.panelData = this.model || this.fromDataView;
    this.panelClass = (this.model) ? 'panel-text' : 'lm-list-text';

    if (this.panelHeader && this.panelHeader.hasOwnProperty('hasRichTextVars')) {
      this.panelHeaderRichTextVars = true;
    }

    if (this.panelText && this.panelText.hasOwnProperty('hasRichTextVars')) {
      this.panelTextRichTextVars = true;
    }
  }
}
